import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/menu/footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/menu/topbar/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/ui-elements/LoadingScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/ui-elements/ToasterProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/providers/CompanyProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"app/lib/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../../public/font/Quicksand-Light.woff2\",\"weight\":\"300\",\"style\":\"normal\"},{\"path\":\"../../public/font/Quicksand-Regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../../public/font/Quicksand-Medium.woff2\",\"weight\":\"500\",\"style\":\"normal\"},{\"path\":\"../../public/font/Quicksand-Bold.woff2\",\"weight\":\"700\",\"style\":\"normal\"}],\"variable\":\"--font-quicksand\"}],\"variableName\":\"quicksand\"}");
